import React from 'react';
import { useSelector } from 'react-redux';
import './styles.css'; // à créer juste en dessous

const Profil = () => {
  const user = useSelector((state) => state.auth.user);

  if (!user) {
    return <div className="loading">Chargement des informations...</div>;
  }

  return (
    <div className="profil-container">
      <div className="profil-card">
        <h1 className="profil-title">Mon Profil</h1>

        <section className="profil-section">
          <h2>Informations personnelles</h2>
          <ul>
            <li><strong>Nom :</strong> {user.lastNameUser}</li>
            <li><strong>Prénom :</strong> {user.firstNameUser}</li>
            <li><strong>Email :</strong> {user.mailUser}</li>
            <li><strong>Adresse :</strong> {user.addressUser}</li>
            <li><strong>Code postal :</strong> {user.postalCodeUser}</li>
            <li><strong>Ville :</strong> {user.cityUser}</li>
          </ul>
        </section>

        {user.company && (
          <section className="profil-section">
            <h2>Mon entreprise</h2>
            <ul>
              <li><strong>Raison sociale :</strong> {user.company.nameCompany}</li>
              <li><strong>Siret :</strong> {user.company.identifierCompany}</li>
              
            </ul>
            <div className="video-container">
                <video 
                    controls 
                    src={`https://intereseaux-api.bonnardwebeditions.fr/api/files?categorie=videos&file=${user.company.srcVideoPresentation}`}
                />
            </div>


            {user.company.services?.length > 0 && (
              <div className="services-list">
                <h3>Services proposés</h3>
                {user.company.services.map((service) => (
                  <div key={service.idService} className="service-card">
                    <p><strong>Titre :</strong> {service.nameService}</p>
                    <p><strong>Description :</strong> {service.descriptionService}</p>
                    <p><strong>Prix :</strong> {service.priceService} €</p>

                    {service.servicesComplementaires?.length > 0 && (
                      <div className="complementaires">
                        <p><strong>Services complémentaires :</strong></p>
                        <ul>
                            {service.servicesComplementaires.map((sub) => (
                                <li key={sub.idService}>
                                    <div>
                                        <p><strong>Titre :</strong> {sub.nameService}</p>
                                        <p><strong>Description :</strong> {sub.descriptionService}</p>
                                        <p><strong>Prix :</strong> {sub.priceService} €</p>

                                    </div>
                                </li>
                            
                        
                          
                            
                                                        

                          ))}
                          </ul>
                      </div>
                    )}

                    {service.realisations?.length > 0 && (
                      <div className="realisations">
                        <p><strong>Réalisations :</strong></p>
                        {service.realisations.map((real) => (
                          <div key={real.idRealisation} className="realisation">
                            <p><strong>Titre :</strong> {real.titleRealisation}</p>
                            <p><strong>Description :</strong> {real.descriptionRealisation}</p>

                            {real.photosRealisation?.length > 0 && (
                              <div className="photos-grid">
                                {real.photosRealisation.map((photo) => (
                                  <img
                                    key={photo.idPhotoRealisation}
                                    src={`https://intereseaux-api.bonnardwebeditions.fr/api/files?categorie=realisations&file=${photo.urlPhotoRealisation}`}
                                    alt="photo"
                                  />
                                ))}
                              </div>
                            )}
                          </div>
                        ))}
                      </div>
                    )}
                  </div>
                ))}
              </div>
            )}
          </section>
        )}
      </div>
    </div>
  );
};

export default Profil;
